import { render, staticRenderFns } from "./CVTypeAwards.vue?vue&type=template&id=26109464"
import script from "./CVTypeAwards.vue?vue&type=script&lang=js"
export * from "./CVTypeAwards.vue?vue&type=script&lang=js"
import style0 from "./CVTypeAwards.vue?vue&type=style&index=0&id=26109464&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports